import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import SelectBanks from "../select/SelectBanks";

export default function FormSelectBank({
  inputValue,
  inputOnChange,
  disabledInput,
}: {
  inputValue: string;
  inputOnChange: (id: string, name: string) => void;
  disabledInput: boolean;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const inputOnChangeSelect = (id: string, name: string) => {
    inputOnChange(id, name);
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className="col-md-12 mt-3">
      <div className="generalStyles__flex">
        <div className="generalStyles__inputFlexNameLarge">
          <span className="generalStyles__inputFlexRequired">*</span>
          <span>{t("general.bank")}</span>
        </div>
        <div className="generalStyles__width100">
          <SelectBanks
            inputValue={inputValue}
            inputOnChange={inputOnChangeSelect}
            disabledInput={disabledInput}
          />
        </div>
        <div className="generalStyles__infoTooltipIconBlank" />
      </div>
    </div>
  );
}
